var render = function render(){var _vm=this,_c=_vm._self._c;return _c('navbar',{attrs:{"navbar-menu-classes":"navbar-right"}},[_c('template',{slot:"navbar-menu"},[_c('div',{staticClass:"mx-auto d-block",staticStyle:{"width":"150px","padding-bottom":"15px"}},[_c('RemoteImg',{attrs:{"alt":"imagem","src":_vm.logoLogin}})],1)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }